export default __webpack_public_path__ + "static/media/Ballroll_00352.5226600a.png";